
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './views/login/login.component';

import { AuthGuard } from './_helpers/auth.guard';


const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'main', canActivate: [AuthGuard],
    loadChildren: () => import('./views/container/container.module').then(m => m.ContainerModule)
  },
  {
    path: "**", redirectTo: '/login', pathMatch: 'full' // 萬用路徑，路由沒有比對到，永遠會執行
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

